import React from 'react';

import { Box, Typography } from '@mui/material';

export const LeaderboardNoScore = ({ title, description }: { title: string; description: string }) => {
  return (
    <Box
      width={392}
      boxShadow={(theme) => theme.customShadows.boxShadow}
      sx={{ borderRadius: 4, height: 'fit-content' }}
    >
      <Box sx={{ backgroundColor: '#1BFFAF', px: 7, py: 4, borderRadius: '12px 12px 0 0' }}>
        <Typography variant="h4" color="grey.900">
          {title}
        </Typography>
      </Box>
      <Box
        sx={{
          backgroundColor: (theme) => (theme.palette.mode === 'light' ? 'grey.200' : 'grey.700'),
          borderRadius: '0 0 12px 12px',
          py: 20,
        }}
      >
        <Typography
          textAlign="center"
          margin="0 auto"
          variant="text1"
          display="flex"
          justifyContent="center"
          px={10}
          width={355}
        >
          {description}
        </Typography>
      </Box>
    </Box>
  );
};
